'use client';

import { CustomLinkProps, useSearchParamsObject } from 'common-nextjs';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { qsStringify } from 'utils';

export default function PageNumberLink({
  children,
  pageNumber,
  ...props
}: CustomLinkProps & {
  pageNumber?: number | null;
}) {
  const pathname = usePathname();
  const params = useSearchParamsObject<{ page?: string }>();

  return (
    <Link
      prefetch={false}
      {...props}
      href={`${pathname}${qsStringify({
        ...params,
        page: pageNumber == 1 ? null : pageNumber,
      })}`}
    >
      {children}
    </Link>
  );
}
